var Block_Scroll = {
    _barre_dragging: false,
    _y_mouse_start: false,
    _y_barre_start: 0,
    _current_slide: -1,
    _swiper_illus: "",
    _swiper_content: "",
    _mobile_first_init: false,
    init: function () {
        $(window).resize(function () {
            Block_Scroll.resize();
        });
        $(window).scroll(function () {
            Block_Scroll.scroll();
        })
        Block_Scroll.resize();
        Block_Scroll.scroll();

        $(".block-scroll .barre").on("mousedown", function (e) {
            $(this).addClass("dragging");
            Block_Scroll._barre_dragging = $(this);
            Block_Scroll._y_barre_start = parseFloat($(this).css("top"));
            Block_Scroll._y_mouse_start = e.clientY;
        });
        $(window).on("mousemove", function (e) {
            if (Block_Scroll._barre_dragging != false) {
                var _current_y = e.clientY;
                Block_Scroll.drag_barre(_current_y - Block_Scroll._y_mouse_start);
            }

        }).on("mouseup", function () {
            if (Block_Scroll._barre_dragging != false) {
                Block_Scroll._barre_dragging = false;
                $(".block-scroll .barre").removeClass("dragging");
            }
        });


        Block_Scroll._swiper_illus = new Swiper(".block-scroll .content.mobile .illustration-swiper", {
            speed: 600,
            loop: false,
            slidesPerView: "auto",
            centeredSlides: false,

            scrollbar: {
                el: ".swiper-scrollbar",
                hide: false,
                draggable: true
            },
            on: {
                transitionStart: function () {
                    Block_Scroll.change_slide_mobile(this.activeIndex, "illus");
                },
            }
        })
        Block_Scroll._swiper_content = new Swiper(".block-scroll .items-swiper", {
            slidesPerView: 1,
            effect: "creative",
            creativeEffect: {
                prev: {
                    shadow: false,
                    opacity: 0,
                    translate: ["-10%", 0, 0],
                },
                next: {
                    shadow: false,
                    opacity: 0,
                    translate: ["10%", 0, 0],
                },
            },

            on: {
                transitionStart: function () {
                    Block_Scroll.change_slide_mobile(this.activeIndex, "content");
                },
            }
        });

        Block_Scroll.change_data(0);
    },
    change_slide_mobile: function (pID, pOrigin) {
        if ($(".block-scroll .mobile").css("display") == "flex") {
            if (pOrigin != 'illus') {
                Block_Scroll._swiper_illus.slideTo(pID);
            }
            if (pOrigin != 'content') {
                Block_Scroll._swiper_content.slideTo(pID);
            }
            Block_Scroll.play_svg(pID);

        }
    },
    drag_barre: function (pValue) {

        var _y_dest = Block_Scroll._y_barre_start + pValue;
        var _limit_top = 0;
        var _limit_bottom = Block_Scroll._barre_dragging.parent().height() - Block_Scroll._barre_dragging.height();

        _y_dest = Math.min(_limit_bottom, Math.max(_limit_top, _y_dest));

        var _pourcent = (_y_dest * 100) / _limit_bottom;

        var _parent = Block_Scroll._barre_dragging.closest(".block-scroll");

        var _scroll_start = _parent.offset().top;
        var _scroll_end = _parent.offset().top + _parent.outerHeight();
        var _espace_scroll = _parent.outerHeight() - $(window).outerHeight();


        var _scrollDest = Math.round(_scroll_start + ((_espace_scroll * _pourcent) / 100));
        $("html,body").animate({scrollTop: _scrollDest}, 0);


        Block_Scroll._barre_dragging.css({top: _y_dest + "px"});
    },
    resize: function () {
        Block_Scroll.scroll();
    },
    scroll: function () {

        if ($(".block-scroll .mobile").css("display") == "flex") {
            $(".block-scroll").each(function () {

                console.log("EACH  " + $(this).hasClass("reveal-visible"));

                if ($(this).hasClass("reveal-visible")) {

                    if(Block_Scroll._mobile_first_init == false){
                        console.log("FIRST INIT");
                        Block_Scroll._mobile_first_init = true;
                        Block_Scroll.play_svg(0);
                    }
                }else{
                    if(Block_Scroll._mobile_first_init == true){
                        console.log("LISTEN AGAIN");
                        Block_Scroll._mobile_first_init = false;
                    }
                }
            });

        }


        $(".block-scroll").each(function () {
            if ($(this).hasClass("reveal-visible")) {

                var _current_scroll = $(this).find(".scroller.reveal-visible").index();
                if (_current_scroll != -1) {
                    Block_Scroll.change_data(_current_scroll);
                }
                if (Block_Scroll._barre_dragging == false) {
                    Block_Scroll.move_cursor($(this));
                }
            }
        })
    },
    play_svg: function (pID) {

        console.log("PLAY SVG : " + pID);

        $(".block-scroll .illustration").each(function () {
            $(this).removeClass("prev next current");
            if ($(this).index() == pID) {
                $(this).addClass("current");
                console.log("ILLUSTRATION FOUND : " + $('.illustration.current svg').length);
                if ($('.illustration.current svg').length > 0) {
                    document.querySelectorAll('.illustration.current').forEach(function (item) {
                        item.querySelectorAll("svg").forEach(function(svg){
                            svg.dispatchEvent(new Event("click"));
                        })
                    });
                }

            } else if ($(this).index() < pID) {
                $(this).addClass("prev");
            } else {
                $(this).addClass("next");
            }
        });
    },
    change_data: function (pID) {
        if (pID != Block_Scroll._current_slide) {

            console.log("CHANGE DATA :" + pID);

            Block_Scroll._current_slide = pID;

            Block_Scroll.play_svg(pID);

            $(".block-scroll .items-container").find(".item").each(function () {
                $(this).removeClass("prev next current");
                if ($(this).index() == pID) {
                    $(this).addClass("current");
                    var _y_pos = -1 * ($(this).offset().top - $(this).parent().offset().top);
                    var _middle = $(this).parent().innerHeight() / 2;
                    var h_content = $(this).innerHeight() / 2;

                    _y_pos = (_y_pos + _middle) - h_content;

                    Debug.log("Y Pos = " + _y_pos);

                    $(this).parent().css({
                        "-webkit-transform": "translateY(" + _y_pos + "px)",
                        "transform": "translateY(" + _y_pos + "px)"
                    })

                } else if ($(this).index() < pID) {
                    $(this).addClass("prev");
                } else {
                    $(this).addClass("next");
                }
            });
        }
    },
    move_cursor: function (pTarget) {
        var _espace_mvt = pTarget.find(".barre-scroll-content").height() - pTarget.find(".barre").height();
        var _scroll_begin = Math.round(pTarget.offset().top);
        var _scroll_end = Math.round(pTarget.outerHeight() - $(window).outerHeight());

        var _current_scroll = Math.round($(window).scrollTop() - _scroll_begin);

        var _pourcent = (_current_scroll * 100) / _scroll_end;
        _pourcent = Math.round(_pourcent * 100) / 100;

        var _y_dest = Math.round((_espace_mvt * _pourcent) / 100);

        pTarget.find(".barre").css({top: _y_dest});

    }
}

$(window).load(function () {
    if ($(".block-scroll").length) {
        Block_Scroll.init();
    }
})